export default __webpack_public_path__ + "static/media/checkinbuttonMain.f6234e66.png";